import { useTranslation } from 'react-i18next';
import { Icon, Menu, Popup } from 'semantic-ui-react';
import { useSelector } from 'react-redux';
import { UserDTO } from '@behavior/init/dto/UserDTO';
import { AuthoritiesDTO } from '@behavior/init/dto/AuthoritiesDTO';

const UserRoleMenuItem = () => {
  const { t } = useTranslation();
  const user = useSelector((state: { init: { user: UserDTO } }) => state?.init?.user);

  const userRoles = user?.authorities
    ? user.authorities
        .filter((authority, index) => takePublicRoleOnlyIfNecessary(user, index))
        .map((authority, index) => getRoleFromAuthority(authority, index))
    : null;

  return (
    <Menu.Item>
      <Popup
        className="userRoles"
        on="click"
        trigger={<Icon name="user" />}
        size="mini"
        position="bottom right"
      >
        <p>{`${t('header.list.user.roles')}:`}</p>
        {userRoles}
      </Popup>
    </Menu.Item>
  );
};

export default UserRoleMenuItem;

function takePublicRoleOnlyIfNecessary(user: UserDTO, index: number) {
  const isPublicRole = user?.authorities[index]?.authority === 'ROLE_PUB';
  const hasOnlyPublicRole = user?.authorities?.length === 1 && isPublicRole;
  return !isPublicRole || hasOnlyPublicRole;
}

function getRoleFromAuthority(authority: AuthoritiesDTO, index: number) {
  const { t } = useTranslation();
  const role = authority?.authority;
  return <p key={`roleKey-${index}`}>{t(role)}</p>;
}
